import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useSquawkPlayer } from "./squawk-player/SquawkPlayerContext";

/**
 * Surfaced when the user has a channel selected but the active player hasn't
 * reached "connected" within the grace window — typically the
 * autoplay-blocked-after-reload case on low-MEI origins (dev/staging).
 *
 * Clicking the button re-issues handleChannelSelect under a fresh user
 * gesture, which is what Chrome's autoplay policy requires to let
 * audio.play() through on those origins. On high-MEI production the banner
 * stays hidden because audio resumes inside the grace window.
 */
export const SquawkDisconnectedBanner = () => {
  const { isDisconnectedForBanner, selectedChannel, reconnect } =
    useSquawkPlayer();

  if (!isDisconnectedForBanner || !selectedChannel) return null;

  return (
    <div className="bg-red-50 dark:bg-red-950/40 border-b border-red-200 dark:border-red-900/50 px-4 py-3">
      <div className="mx-auto flex items-center justify-center gap-4 sm:gap-6">
        <ExclamationTriangleIcon className="hidden sm:block h-5 w-5 shrink-0 text-red-500 dark:text-red-400" />
        <div className="text-center sm:text-left">
          <p className="text-sm font-semibold leading-tight text-red-700 dark:text-red-300">
            Squawk disconnected
          </p>
          <p className="mt-0.5 text-xs text-red-600/80 dark:text-red-400/80">
            Audio was interrupted by an update or connection issue. Click
            reconnect to resume {selectedChannel.name}.
          </p>
        </div>
        <button
          onClick={reconnect}
          className="shrink-0 inline-flex items-center px-4 py-1.5 bg-red-600 text-white text-sm font-bold rounded-md hover:bg-red-700 transition-colors shadow-sm cursor-pointer"
        >
          Reconnect
        </button>
      </div>
    </div>
  );
};
